import { render, staticRenderFns } from "./job-page.vue?vue&type=template&id=63f0f4b2&"
import script from "./job-page.vue?vue&type=script&lang=js&"
export * from "./job-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports